import React from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import SvgIcon from "../../../../../parts/SvgIcon";

const TRACK_ADD_LABEL_KEYS = {
  training: "annualPlanner.addTrainingPhase",
  nutrition: "annualPlanner.addNutritionPhase",
};

// Phase-name rows + "+Add" button for one track (Training/Nutrition) - the
// label-column content for that row-group's [label|body] pair in
// CalendarView's .planner-grid. `track` drives which add/edit modal these
// rows write to. The chevron/title/count bar above this (always visible,
// even while these rows are hidden by collapse) is PhaseTrackTitle.js, its
// own full-width row - see that file's comment for why they're split. See
// ~/.claude/plans/periodization-calendar-view-redesign.md Fase 1.
export const PhaseRowHeader = ({ phases, track = "training" }) => {
  const { t } = useTranslation("athlete-portal");

  const openAddIndividualPhaseModal = () => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        "modal[type]": "add-individual-phase",
        track,
      },
    });
  };

  const openEditIndividualPhaseModal = (phase) => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        "modal[type]": "edit-individual-phase",
        phase,
        track,
      },
    });
  };

  return (
    <div className="phase-row-header">
      {(phases || []).map((phase, index) => (
        <div //NOSONAR
          className="phase-name-label"
          key={`phase-row-${track}-${index}`}
          onClick={() => openEditIndividualPhaseModal(phase)}
        >
          <div
            className="phase-color-dot"
            style={{ backgroundColor: phase.phaseColor }}
          />
          <span className="row-header" title={phase.phaseName}>
            {phase.phaseName}
          </span>
        </div>
      ))}
      <div //NOSONAR
        role="button"
        data-button-type="outline"
        className="add-phase-button"
        onClick={openAddIndividualPhaseModal}
      >
        <SvgIcon
          src="/img/new-icons/add-28.svg"
          useCurrentColor
          classNames="icon-sm"
        />
        <span>{t(TRACK_ADD_LABEL_KEYS[track])}</span>
      </div>
    </div>
  );
};
